import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  return {
    outerContainer: {
      paddingTop: '1rem',
      paddingLeft: '1rem',
      paddingRight: '1rem',
      paddingBottom: '3.5rem',
    },
    profileContainer: {
      padding: '2rem 3rem',
    },
    profileContentContainer: {
      display: 'flex',
    },
    profileImageError: {
      borderRadius: '100%',
      height: '120px',
      objectFit: 'contain',
      width: '120px',
      border: '1px solid rgba(0, 0, 0, 0.2)',
      textAlign: 'center',
    },
    profileImage: {
      borderRadius: '100%',
      height: '120px',
      objectFit: 'contain',
      width: '120px',
      border: '1px solid rgba(0, 0, 0, 0.2)',
    },
    profileTextContainer: {
      marginLeft: '2.5rem',
    },
    name: {
      fontSize: '1.7rem',
    },
    jursyNumberContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    jursyNumberLabel: {
      fontSize: '1rem',
      marginTop: '0.5rem',
      marginBottom: '0.5rem',
    },
    editDetailsButtonContainer: {
      marginTop: '1rem',
    },
    profileButton: {
      marginTop: '0.5rem',
      textTransform: 'capitalize',
      width: '200px',
      justifyContent: 'flex-start',
    },
    activeButton: {
      backgroundColor: '#4caf50',
      '&:hover': {
        backgroundColor: '#357a38',
      },
    },
    blockButton: {
      backgroundColor: '#f44336',
      '&:hover': {
        backgroundColor: '#aa2e25',
      },
    },
    tabsContainer: {
      margin: '1rem 0rem',
    },
    tabPanelContainer: {
      padding: '0rem',
    },
    dialogMessageLabel: {
      fontWeight: 'bold',
    },
    activateLabel: {
      color: 'green',
    },
    deactivateLabel: {
      color: 'red',
    },
    userProfileRoleContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    userProfileRoleIcon: {
      fontSize: '1.2rem',
      color: 'blue',
    },
    userProfileRole: {
      fontSize: '1rem',
      marginTop: '0.5rem',
      marginBottom: '0.5rem',
      marginLeft: '0.3rem',
    },
    breadcrumbsContainer: {
      position: 'sticky',
      zIndex: '1000',
      top: '0',
      marginTop: '-16px',
      marginLeft: '-25px',
      marginRight: '-25px',
      paddingLeft: '16px',
    },
    breadcrumbsContainerForUsers: {
      position: 'sticky',
      zIndex: '1000',
      top: '75px',
      marginTop: '-16px',
      marginLeft: '-15px',
      marginRight: '-25px',
    },
    breadcrumbsContainerForAdmins: {
      position: 'sticky',
      zIndex: '1000',
      top: '0px',
      marginTop: '-28px',
      marginLeft: '-15px',
      marginRight: '-25px',
    },
    breadcrumbItem: {
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none',
      color: theme.palette.text.primary,
      padding: '4px 0px',
    },
    activeBreadcrumbItem: {
      color: theme.palette.primary.main,
    },
    breadcrumpIcon: {
      marginRight: '5px',
      fontSize: '18px',
    },
    breadcrumpLabel: {
      fontSize: '14px',
    },
  };
});
